var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueFolderLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 40,
    viewBox: "0 0 49 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.5996 2.30664H46.5496C48.0196 2.30664 48.9996 3.22899 48.9996 4.61252V9.22429H19.5996V2.30664Z",
    fill: "#4776E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.64 0H2.45C0.98 0 0 0.922353 0 2.30588V36.8941C0 38.2776 0.98 39.2 2.45 39.2H46.55C48.02 39.2 49 38.2776 49 36.8941V9.22353C49 7.84 48.02 6.91765 46.55 6.91765H24.5L20.58 1.38355C20.09 0.461199 18.865 0 17.64 0Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFolderLargeIcon);
export default __webpack_public_path__ + "static/media/blue-folder-large-icon.c98f4a8efd1f17c79c3ff9678638423a.svg";
export { ForwardRef as ReactComponent };